export const Logo = () => (
  <svg
    width="126"
    height="36"
    viewBox="0 0 126 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect width="126" height="36" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_3_3" transform="scale(0.00793651 0.0277778)" />
      </pattern>
      <image
        id="image0_3_3"
        width="126"
        height="36"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const UploadIcon = () => (
  <svg
    width="34"
    height="39"
    viewBox="0 0 34 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.1429 26.8125V31.6875C29.1429 33.0335 28.0553 34.125 26.7143 34.125H7.28571C5.94469 34.125 4.85714 33.0335 4.85714 31.6875V26.8125C4.85714 25.4665 3.7696 24.375 2.42857 24.375C1.08754 24.375 0 25.4665 0 26.8125V31.6875C0 35.7261 3.26187 39 7.28571 39H26.7143C30.7381 39 34 35.7261 34 31.6875V26.8125C34 25.4665 32.9125 24.375 31.5714 24.375C30.2304 24.375 29.1429 25.4643 29.1429 26.8125ZM15.2848 0.714107L5.57054 10.4641C4.62112 11.417 4.62263 12.9595 5.57054 13.9109C6.5192 14.863 8.05603 14.863 9.00469 13.9109L14.5714 8.32558V24.375C14.5714 25.7225 15.6575 26.8125 17 26.8125C18.3425 26.8125 19.4286 25.7225 19.4286 24.375V8.32558L24.9976 13.9151C25.9463 14.8672 27.4831 14.8672 28.4317 13.9151C29.3804 12.9629 29.3804 11.4204 28.4317 10.4683L18.7175 0.718297C17.7665 -0.238041 16.2335 -0.238041 15.2848 0.714107Z"
      fill="#8C8C8C"
    />
  </svg>
);

export const UpRightSquare = ({ id }: { id: string }) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath={`url(${id})`}>
      <path
        d="M9 0.9375C8.59688 0.9375 8.23125 1.16602 8.075 1.51758C7.91875 1.86914 8.00625 2.27051 8.29062 2.54004L9.58438 3.75L5.29375 7.77539C4.90312 8.1416 4.90312 8.73633 5.29375 9.10254C5.68437 9.46875 6.31875 9.46875 6.70937 9.10254L11 5.07715L12.2937 6.29004C12.5812 6.55957 13.0094 6.63867 13.3844 6.49219C13.7594 6.3457 14.0031 6.00586 14.0031 5.625V1.875C14.0031 1.35645 13.5563 0.9375 13.0031 0.9375H9ZM2.5 1.875C1.11875 1.875 0 2.92383 0 4.21875V11.7188C0 13.0137 1.11875 14.0625 2.5 14.0625H10.5C11.8813 14.0625 13 13.0137 13 11.7188V9.375C13 8.85645 12.5531 8.4375 12 8.4375C11.4469 8.4375 11 8.85645 11 9.375V11.7188C11 11.9766 10.775 12.1875 10.5 12.1875H2.5C2.225 12.1875 2 11.9766 2 11.7188V4.21875C2 3.96094 2.225 3.75 2.5 3.75H5C5.55313 3.75 6 3.33105 6 2.8125C6 2.29395 5.55313 1.875 5 1.875H2.5Z"
        fill="#0066CC"
      />
    </g>
    <defs>
      <clipPath id={id}>
        <rect width="14" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const InfoIconBlue = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_6)">
      <path
        d="M7.5 15C11.6426 15 15 11.6426 15 7.5C15 3.35742 11.6426 0 7.5 0C3.35742 0 0 3.35742 0 7.5C0 11.6426 3.35742 15 7.5 15ZM6.32812 9.84375H7.03125V7.96875H6.32812C5.93848 7.96875 5.625 7.65527 5.625 7.26562C5.625 6.87598 5.93848 6.5625 6.32812 6.5625H7.73438C8.12402 6.5625 8.4375 6.87598 8.4375 7.26562V9.84375H8.67188C9.06152 9.84375 9.375 10.1572 9.375 10.5469C9.375 10.9365 9.06152 11.25 8.67188 11.25H6.32812C5.93848 11.25 5.625 10.9365 5.625 10.5469C5.625 10.1572 5.93848 9.84375 6.32812 9.84375ZM7.5 5.625C6.98145 5.625 6.5625 5.20605 6.5625 4.6875C6.5625 4.16895 6.98145 3.75 7.5 3.75C8.01855 3.75 8.4375 4.16895 8.4375 4.6875C8.4375 5.20605 8.01855 5.625 7.5 5.625Z"
        fill="#0066CC"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_6">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UploadIconBlue = () => (
  <svg
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8_430)">
      <path
        d="M11.1429 10.3126V12.1876C11.1429 12.7053 10.727 13.1251 10.2143 13.1251H2.78571C2.27297 13.1251 1.85714 12.7053 1.85714 12.1876V10.3126C1.85714 9.79491 1.44132 9.37509 0.928571 9.37509C0.415826 9.37509 0 9.79491 0 10.3126V12.1876C0 13.7409 1.24719 15.0001 2.78571 15.0001H10.2143C11.7528 15.0001 13 13.7409 13 12.1876V10.3126C13 9.79491 12.5842 9.37509 12.0714 9.37509C11.5587 9.37509 11.1429 9.79403 11.1429 10.3126ZM5.8442 0.274747L2.12991 4.02475C1.7669 4.39125 1.76748 4.98451 2.12991 5.35043C2.49263 5.71664 3.08025 5.71664 3.44297 5.35043L5.57143 3.20224V9.37509C5.57143 9.89335 5.98667 10.3126 6.5 10.3126C7.01333 10.3126 7.42857 9.89335 7.42857 9.37509V3.20224L9.5579 5.35204C9.92062 5.71825 10.5082 5.71825 10.871 5.35204C11.2337 4.98583 11.2337 4.39257 10.871 4.02636L7.15667 0.276358C6.79308 -0.0914639 6.20692 -0.0914639 5.8442 0.274747Z"
        fill="#0071E3"
      />
    </g>
    <defs>
      <clipPath id="clip0_8_430">
        <rect width="13" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DPIErrorIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8_122)">
      <path
        d="M15.8218 13.0312L9.15615 1.65625C8.64583 0.78125 7.35802 0.78125 6.84427 1.65625L0.181769 13.0312C-0.331044 13.9031 0.307675 15 1.33552 15H14.6668C15.6905 15 16.3312 13.9062 15.8218 13.0312ZM7.2499 5.25C7.2499 4.83594 7.58583 4.5 7.9999 4.5C8.41396 4.5 8.7499 4.8375 8.7499 5.25V9.25C8.7499 9.66406 8.41396 10 8.02802 10C7.64208 10 7.2499 9.66562 7.2499 9.25V5.25ZM7.9999 13C7.4574 13 7.0174 12.56 7.0174 12.0175C7.0174 11.475 7.45708 11.035 7.9999 11.035C8.54271 11.035 8.9824 11.475 8.9824 12.0175C8.98115 12.5594 8.54365 13 7.9999 13Z"
        fill="#F10000"
      />
    </g>
    <defs>
      <clipPath id="clip0_8_122">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DPILowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8_278)">
      <path
        d="M15.8218 13.0312L9.15615 1.65625C8.64583 0.78125 7.35802 0.78125 6.84427 1.65625L0.181769 13.0312C-0.331044 13.9031 0.307675 15 1.33552 15H14.6668C15.6905 15 16.3312 13.9062 15.8218 13.0312ZM7.2499 5.25C7.2499 4.83594 7.58583 4.5 7.9999 4.5C8.41396 4.5 8.7499 4.8375 8.7499 5.25V9.25C8.7499 9.66406 8.41396 10 8.02802 10C7.64208 10 7.2499 9.66562 7.2499 9.25V5.25ZM7.9999 13C7.4574 13 7.0174 12.56 7.0174 12.0175C7.0174 11.475 7.45708 11.035 7.9999 11.035C8.54271 11.035 8.9824 11.475 8.9824 12.0175C8.98115 12.5594 8.54365 13 7.9999 13Z"
        fill="#F3DB00"
      />
    </g>
    <defs>
      <clipPath id="clip0_8_278">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CheckGreenIcon = () => (
  <svg
    width="17"
    height="19"
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8_299)">
      <path
        d="M16.6433 3.91133C17.1176 4.3752 17.1176 5.12481 16.6433 5.58867L6.92902 15.0887C6.45469 15.5525 5.68817 15.5525 5.21384 15.0887L0.355634 10.3387C-0.118545 9.87481 -0.118545 9.1252 0.355634 8.66133C0.829888 8.19746 1.59868 8.19746 2.07301 8.66133L6.03728 12.5689L14.9281 3.91133C15.4025 3.44672 16.169 3.44672 16.6433 3.91133Z"
        fill="#34C759"
      />
    </g>
    <defs>
      <clipPath id="clip0_8_299">
        <rect width="17" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RecycleIcon = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.14023 5.14023C8.81289 2.46758 13.1313 2.45469 15.8211 5.09727L14.0508 6.86328C13.7543 7.15977 13.6684 7.60234 13.8273 7.98906C13.9863 8.37578 14.3645 8.625 14.7812 8.625H19.916H20.2812C20.8527 8.625 21.3125 8.16523 21.3125 7.59375V2.09375C21.3125 1.67695 21.0633 1.29883 20.6766 1.13984C20.2898 0.980859 19.8473 1.0668 19.5508 1.36328L17.7633 3.15078C13.9992 -0.566016 7.93633 -0.553125 4.19375 3.19375C3.14531 4.24219 2.38906 5.47539 1.925 6.79453C1.67148 7.51211 2.04961 8.29414 2.76289 8.54766C3.47617 8.80117 4.2625 8.42305 4.51602 7.70976C4.84687 6.77305 5.38398 5.89219 6.14023 5.14023ZM0.6875 12.4062V12.7328V12.7629V17.9063C0.6875 18.323 0.936719 18.7012 1.32344 18.8602C1.71016 19.0191 2.15273 18.9332 2.44922 18.6367L4.23672 16.8492C8.00078 20.566 14.0637 20.5531 17.8062 16.8063C18.8547 15.7578 19.6152 14.5246 20.0793 13.2098C20.3328 12.4922 19.9547 11.7102 19.2414 11.4566C18.5281 11.2031 17.7418 11.5813 17.4883 12.2945C17.1574 13.2312 16.6203 14.1121 15.8641 14.8641C13.1914 17.5367 8.87305 17.5496 6.1832 14.907L7.94922 13.1367C8.2457 12.8402 8.33164 12.3977 8.17266 12.0109C8.01367 11.6242 7.63555 11.375 7.21875 11.375H2.07969H2.04961H1.71875C1.14727 11.375 0.6875 11.8348 0.6875 12.4062Z"
      fill="#0066CC"
    />
  </svg>
);

export const FolderImage = () => (
  <svg
    width="30"
    height="39"
    viewBox="0 0 30 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4.875C0 2.18613 2.24219 0 5 0H17.5V9.75C17.5 11.0982 18.6172 12.1875 20 12.1875H30V34.125C30 36.8139 27.7578 39 25 39H5C2.24219 39 0 36.8139 0 34.125V4.875ZM30 9.75H20V0L30 9.75Z"
      fill="black"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg
    width="13"
    height="11"
    viewBox="0 0 13 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0377 0.499603C12.3575 0.914642 12.3575 1.58867 12.0377 2.0037L5.48938 10.5037C5.16963 10.9187 4.65037 10.9187 4.33063 10.5037L1.05646 6.25371C0.736715 5.83867 0.736715 5.16464 1.05646 4.7496C1.3762 4.33456 1.89546 4.33456 2.21521 4.7496L4.91128 8.24589L10.8815 0.499603C11.2013 0.0845642 11.7205 0.0845642 12.0403 0.499603H12.0377Z"
      fill="#0066CC"
    />
  </svg>
);

export const AspectRatioError = () => (
  <svg
    width="13"
    height="20"
    viewBox="0 0 13 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8_130)">
      <path
        d="M12.6181 14.1172C13.1259 14.6055 13.1259 15.3965 12.6181 15.8848C12.3663 16.1289 12.0331 16.25 11.7 16.25C11.3669 16.25 11.0346 16.1279 10.7811 15.8838L6.5 11.7695L2.21934 15.8828C1.96544 16.1289 1.63272 16.25 1.3 16.25C0.967281 16.25 0.634969 16.1289 0.380859 15.8828C-0.126953 15.3945 -0.126953 14.6035 0.380859 14.1152L4.66273 9.99805L0.380859 5.88281C-0.126953 5.39453 -0.126953 4.60352 0.380859 4.11523C0.888672 3.62695 1.71133 3.62695 2.21914 4.11523L6.5 8.23437L10.7819 4.11719C11.2897 3.62891 12.1123 3.62891 12.6202 4.11719C13.128 4.60547 13.128 5.39648 12.6202 5.88476L8.33828 10.002L12.6181 14.1172Z"
        fill="#F10000"
      />
    </g>
    <defs>
      <clipPath id="clip0_8_130">
        <rect width="13" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UploadcheckBox = () => (
  <svg
    width="207"
    height="152"
    viewBox="0 0 207 152"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="205"
      height="150"
      rx="11"
      fill="white"
      stroke="#CCCCCC"
      stroke-width="2"
    />
    <g clipPath="url(#clip0_301_34)">
      <path
        d="M22 104C28.0758 104 33 99.0758 33 93C33 86.9242 28.0758 82 22 82C15.9242 82 11 86.9242 11 93C11 99.0758 15.9242 104 22 104ZM26.8555 90.9805L21.3555 96.4805C20.9516 96.8844 20.2984 96.8844 19.8988 96.4805L17.1488 93.7305C16.7449 93.3266 16.7449 92.6734 17.1488 92.2738C17.5527 91.8742 18.2059 91.8699 18.6055 92.2738L20.625 94.2934L25.3945 89.5195C25.7984 89.1156 26.4516 89.1156 26.8512 89.5195C27.2508 89.9234 27.2551 90.5766 26.8512 90.9762L26.8555 90.9805Z"
        fill="#34C759"
      />
    </g>
    <line
      x1="46.5"
      y1="93.5"
      x2="190.5"
      y2="93.5"
      stroke="#CCCCCC"
      stroke-width="5"
      stroke-linecap="round"
    />
    <path
      d="M17.1402 119.14C19.8129 116.468 24.1313 116.455 26.8211 119.097L25.0508 120.863C24.7543 121.16 24.6684 121.602 24.8273 121.989C24.9863 122.376 25.3645 122.625 25.7812 122.625H30.916H31.2812C31.8527 122.625 32.3125 122.165 32.3125 121.594V116.094C32.3125 115.677 32.0633 115.299 31.6766 115.14C31.2898 114.981 30.8473 115.067 30.5508 115.363L28.7633 117.151C24.9992 113.434 18.9363 113.447 15.1937 117.194C14.1453 118.242 13.3891 119.475 12.925 120.795C12.6715 121.512 13.0496 122.294 13.7629 122.548C14.4762 122.801 15.2625 122.423 15.516 121.71C15.8469 120.773 16.384 119.892 17.1402 119.14ZM11.6875 126.406V126.733V126.763V131.906C11.6875 132.323 11.9367 132.701 12.3234 132.86C12.7102 133.019 13.1527 132.933 13.4492 132.637L15.2367 130.849C19.0008 134.566 25.0637 134.553 28.8062 130.806C29.8547 129.758 30.6152 128.525 31.0793 127.21C31.3328 126.492 30.9547 125.71 30.2414 125.457C29.5281 125.203 28.7418 125.581 28.4883 126.295C28.1574 127.231 27.6203 128.112 26.8641 128.864C24.1914 131.537 19.873 131.55 17.1832 128.907L18.9492 127.137C19.2457 126.84 19.3316 126.398 19.1727 126.011C19.0137 125.624 18.6355 125.375 18.2188 125.375H13.0797H13.0496H12.7188C12.1473 125.375 11.6875 125.835 11.6875 126.406Z"
      fill="#0066CC"
    />
    <line
      x1="46.5"
      y1="124.5"
      x2="149.5"
      y2="124.5"
      stroke="#CCCCCC"
      stroke-width="5"
      stroke-linecap="round"
    />
    <g clipPath="url(#clip1_301_34)">
      <path
        d="M22 73C28.0758 73 33 68.0758 33 62C33 55.9242 28.0758 51 22 51C15.9242 51 11 55.9242 11 62C11 68.0758 15.9242 73 22 73ZM26.8555 59.9805L21.3555 65.4805C20.9516 65.8844 20.2984 65.8844 19.8988 65.4805L17.1488 62.7305C16.7449 62.3266 16.7449 61.6734 17.1488 61.2738C17.5527 60.8742 18.2059 60.8699 18.6055 61.2738L20.625 63.2934L25.3945 58.5195C25.7984 58.1156 26.4516 58.1156 26.8512 58.5195C27.2508 58.9234 27.2551 59.5766 26.8512 59.9762L26.8555 59.9805Z"
        fill="#34C759"
      />
    </g>
    <line
      x1="46.5"
      y1="62.5"
      x2="190.5"
      y2="62.5"
      stroke="#CCCCCC"
      stroke-width="5"
      stroke-linecap="round"
    />
    <g clipPath="url(#clip2_301_34)">
      <path
        d="M22 42C28.0758 42 33 37.0758 33 31C33 24.9242 28.0758 20 22 20C15.9242 20 11 24.9242 11 31C11 37.0758 15.9242 42 22 42ZM26.8555 28.9805L21.3555 34.4805C20.9516 34.8844 20.2984 34.8844 19.8988 34.4805L17.1488 31.7305C16.7449 31.3266 16.7449 30.6734 17.1488 30.2738C17.5527 29.8742 18.2059 29.8699 18.6055 30.2738L20.625 32.2934L25.3945 27.5195C25.7984 27.1156 26.4516 27.1156 26.8512 27.5195C27.2508 27.9234 27.2551 28.5766 26.8512 28.9762L26.8555 28.9805Z"
        fill="#34C759"
      />
    </g>
    <line
      x1="46.5"
      y1="31.5"
      x2="190.5"
      y2="31.5"
      stroke="#CCCCCC"
      stroke-width="5"
      stroke-linecap="round"
    />
    <defs>
      <clipPath id="clip0_301_34">
        <rect
          width="22"
          height="22"
          fill="white"
          transform="translate(11 82)"
        />
      </clipPath>
      <clipPath id="clip1_301_34">
        <rect
          width="22"
          height="22"
          fill="white"
          transform="translate(11 51)"
        />
      </clipPath>
      <clipPath id="clip2_301_34">
        <rect
          width="22"
          height="22"
          fill="white"
          transform="translate(11 20)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const XMarkIcon = () => (
  <svg
    width="12"
    height="19"
    viewBox="0 0 12 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_102_40)">
      <path
        d="M11.6475 13.4113C12.1162 13.8752 12.1162 14.6267 11.6475 15.0905C11.415 15.3225 11.1075 15.4375 10.8 15.4375C10.4925 15.4375 10.1858 15.3215 9.95175 15.0896L6 11.1811L2.04862 15.0887C1.81425 15.3225 1.50712 15.4375 1.2 15.4375C0.892875 15.4375 0.586125 15.3225 0.351562 15.0887C-0.117187 14.6248 -0.117187 13.8733 0.351562 13.4095L4.30406 9.49814L0.351562 5.58867C-0.117187 5.1248 -0.117187 4.37334 0.351562 3.90947C0.820312 3.4456 1.57969 3.4456 2.04844 3.90947L6 7.82265L9.9525 3.91133C10.4212 3.44746 11.1806 3.44746 11.6494 3.91133C12.1181 4.37519 12.1181 5.12666 11.6494 5.59052L7.69687 9.50185L11.6475 13.4113Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_102_40">
        <rect width="12" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const FolderIcon = () => (
  <svg
    width="78"
    height="69"
    viewBox="0 0 78 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M68.1128 10.4375H41.8944L34.5362 3.63232C32.7081 1.82613 30.2401 0.8125 27.6503 0.8125H9.61279C4.22744 0.8125 -0.137207 5.1227 -0.137207 10.4375V58.5625C-0.137207 63.8773 4.22744 68.1875 9.61279 68.1875H68.1128C73.4981 68.1875 77.8628 63.8773 77.8628 58.5625V20.0625C77.8628 14.7537 73.6276 10.4375 68.1128 10.4375ZM70.5503 58.5625C70.5503 59.8895 69.4568 60.9688 68.1128 60.9688H9.61279C8.26882 60.9688 7.17529 59.8895 7.17529 58.5625V10.4375C7.17529 9.11045 8.26882 8.03125 9.61279 8.03125H27.5132C28.1641 8.03125 28.7766 8.2815 29.2362 8.73628L38.8628 17.6562H68.1128C69.4568 17.6562 70.5503 18.7355 70.5503 20.0625V58.5625Z"
      fill="#CCCCCC"
    />
  </svg>
);
export const CheckMarkIcon = () => (
  <svg
    width="15"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_111_530)">
      <path
        d="M14.6853 3.49958C15.1038 3.91462 15.1038 4.58532 14.6853 5.00036L6.11384 13.5004C5.69531 13.9154 5.01897 13.9154 4.60045 13.5004L0.313795 9.25036C-0.104598 8.83532 -0.104598 8.16462 0.313795 7.74958C0.732254 7.33454 1.4106 7.33454 1.82913 7.74958L5.32701 11.2459L13.1719 3.49958C13.5904 3.08388 14.2667 3.08388 14.6853 3.49958Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_111_530">
        <rect width="15" height="17" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UploadIconAlt = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.08789 5.34961C3.4541 5.71553 4.04766 5.71582 4.41357 5.34964L6.5625 3.20215V10.3125C6.5625 10.8302 6.98232 11.25 7.5 11.25C8.01768 11.25 8.4375 10.8302 8.4375 10.3125V3.20215L10.5873 5.35195C10.9532 5.71787 11.5468 5.71787 11.913 5.35192C12.2789 4.98601 12.2789 4.39245 11.913 4.02624L8.16299 0.27624C7.98047 0.0915527 7.74023 0 7.5 0C7.25977 0 7.01953 0.0915527 6.83789 0.274658L3.08789 4.02539C2.72109 4.3916 2.72109 4.9834 3.08789 5.34961ZM14.0625 10.3125H9.375C9.375 11.3481 8.53564 12.1875 7.5 12.1875C6.46436 12.1875 5.625 11.3481 5.625 10.3125H0.9375C0.419824 10.3125 0 10.7323 0 11.25V14.0625C0 14.5802 0.419824 15 0.9375 15H14.0625C14.5802 15 15 14.5802 15 14.0625V11.25C15 10.7314 14.5811 10.3125 14.0625 10.3125ZM12.6562 13.3594C12.2695 13.3594 11.9531 13.043 11.9531 12.6562C11.9531 12.2695 12.2695 11.9531 12.6562 11.9531C13.043 11.9531 13.3594 12.2695 13.3594 12.6562C13.3594 13.043 13.043 13.3594 12.6562 13.3594Z"
      fill="black"
    />
  </svg>
);

export const DownloadIconAlt = ({ color }: { color?: string }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0625 10.3125H10.1514L8.82568 11.6382C8.47266 11.9912 8.00098 12.1875 7.5 12.1875C6.99902 12.1875 6.52852 11.9925 6.17432 11.6382L4.84863 10.3125H0.9375C0.419824 10.3125 0 10.7323 0 11.25V14.0625C0 14.5802 0.419824 15 0.9375 15H14.0625C14.5802 15 15 14.5802 15 14.0625V11.25C15 10.7314 14.5811 10.3125 14.0625 10.3125ZM12.6562 13.3594C12.2695 13.3594 11.9531 13.043 11.9531 12.6562C11.9531 12.2695 12.2695 11.9531 12.6562 11.9531C13.043 11.9531 13.3594 12.2695 13.3594 12.6562C13.3594 13.043 13.043 13.3594 12.6562 13.3594ZM6.83789 10.9746C7.01953 11.1592 7.25977 11.25 7.5 11.25C7.74023 11.25 7.97988 11.1584 8.16269 10.9753L11.9127 7.22534C12.2786 6.85913 12.2786 6.26587 11.9127 5.89966C11.5465 5.53345 10.9529 5.53345 10.587 5.89966L8.4375 8.05078V0.9375C8.4375 0.419824 8.01768 0 7.5 0C6.98145 0 6.5625 0.419824 6.5625 0.9375V8.05078L4.41211 5.90039C4.04619 5.53418 3.45264 5.53418 3.08643 5.90039C2.72051 6.2666 2.72051 6.85986 3.08643 7.22607L6.83789 10.9746Z"
      fill={color || "black"}
    />
  </svg>
);

export const WarningIcon = ({ color }: { color?: string }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_111_527)">
      <path
        d="M16.8108 13.8457L9.72859 1.75977C9.18639 0.830078 7.81808 0.830078 7.27222 1.75977L0.193313 13.8457C-0.351551 14.7721 0.327088 15.9375 1.41917 15.9375H15.5836C16.6714 15.9375 17.352 14.7754 16.8108 13.8457ZM7.7032 5.57812C7.7032 5.13818 8.06013 4.78125 8.50008 4.78125C8.94002 4.78125 9.29695 5.13984 9.29695 5.57812V9.82812C9.29695 10.2681 8.94002 10.625 8.52996 10.625C8.1199 10.625 7.7032 10.2697 7.7032 9.82812V5.57812ZM8.50008 13.8125C7.92367 13.8125 7.45617 13.345 7.45617 12.7686C7.45617 12.1922 7.92334 11.7247 8.50008 11.7247C9.07681 11.7247 9.54398 12.1922 9.54398 12.7686C9.54265 13.3443 9.07781 13.8125 8.50008 13.8125Z"
        fill={color || "#F3DB00"}
      />
    </g>
    <defs>
      <clipPath id="clip0_111_527">
        <rect width="17" height="17" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CaretUpIcon = ({
  color,
  handleClick,
}: {
  color?: string | null;
  handleClick?: () => void;
}) => (
  <svg
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={handleClick}
    style={{ cursor: color ? "pointer" : "default" }}
  >
    <g clipPath="url(#clip0_102_48)">
      <path
        d="M7.76516 6.73867L4.58766 3.48867C4.41016 3.32871 4.20516 3.25 4.00016 3.25C3.79516 3.25 3.59066 3.32935 3.43441 3.48804L0.256911 6.73804C0.00577055 6.96973 -0.0627395 7.32012 0.0611104 7.62227C0.18496 7.92441 0.47691 8.125 0.80016 8.125L7.17766 8.125C7.50116 8.125 7.79316 7.92744 7.91716 7.62354C8.04116 7.31964 7.99516 6.96973 7.76516 6.73867Z"
        fill={color || "#868686"}
      />
    </g>
    <defs>
      <clipPath id="clip0_102_48">
        <rect
          width="8"
          height="13"
          fill="white"
          transform="matrix(1 1.74846e-07 1.74846e-07 -1 0 13)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CaretDownIcon = ({
  color,
  handleClick,
}: {
  color?: string | null;
  handleClick?: () => void;
}) => (
  <svg
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={handleClick}
    style={{ cursor: color ? "pointer" : "default" }}
  >
    <path
      d="M0.234839 6.26133L3.41234 9.51133C3.58984 9.67129 3.79484 9.75 3.99984 9.75C4.20484 9.75 4.40934 9.67065 4.56559 9.51196L7.74309 6.26196C7.99423 6.03027 8.06274 5.67988 7.93889 5.37773C7.81504 5.07559 7.52309 4.875 7.19984 4.875H0.82234C0.498839 4.875 0.20684 5.07256 0.08284 5.37646C-0.0411606 5.68037 0.00483942 6.03027 0.234839 6.26133Z"
      fill={color || "#868686"}
    />
  </svg>
);

export const ArrowIcon = ({
  hide = false,
  color,
  strokeWidth = 1,
}: {
  hide?: boolean;
  color?: string;
  strokeWidth?: number;
}) => (
  <svg
    width="19"
    height="10"
    viewBox="0 0 19 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ visibility: hide ? "hidden" : "visible" }}
    strokeWidth={strokeWidth}
  >
    <path d="M1 1L9.5 9L18 1" stroke={color || "#124068"} />
  </svg>
);

export const AttachFile = ({ className = "" }: { className?: string }) => (
  <svg
    width="15"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12.1551 2.78243C11.3449 1.97227 10.0301 1.97227 9.21993 2.78243L3.11056 8.8918C1.71271 10.2897 1.71271 12.5541 3.11056 13.952C4.50841 15.3498 6.77286 15.3498 8.17071 13.952L13.2176 8.90508C13.5795 8.54317 14.1705 8.54317 14.5324 8.90508C14.8943 9.267 14.8943 9.85801 14.5324 10.2199L9.48556 15.2668C7.36056 17.3918 3.92071 17.3918 1.79572 15.2668C-0.329285 13.1418 -0.329285 9.70196 1.79572 7.57696L7.90509 1.46758C9.44239 -0.0697205 11.9326 -0.0697205 13.4699 1.46758C15.0072 3.00489 15.0072 5.49512 13.4699 7.03243L7.62618 12.8762C6.67657 13.8258 5.13595 13.8258 4.18634 12.8762C3.23673 11.9266 3.23673 10.3859 4.18634 9.43633L8.96759 4.65508C9.3295 4.29317 9.92052 4.29317 10.2824 4.65508C10.6443 5.017 10.6443 5.60801 10.2824 5.96993L5.50118 10.7512C5.27872 10.9736 5.27872 11.3389 5.50118 11.5613C5.72364 11.7838 6.08888 11.7838 6.31134 11.5613L12.1551 5.71758C12.9652 4.90743 12.9652 3.59258 12.1551 2.78243Z"
      fill="white"
    />
  </svg>
);

export const CircleCheckSolidIcon = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_301_1691)">
      <path
        d="M5.5 11C6.95869 11 8.35764 10.4205 9.38909 9.38909C10.4205 8.35764 11 6.95869 11 5.5C11 4.04131 10.4205 2.64236 9.38909 1.61091C8.35764 0.579463 6.95869 0 5.5 0C4.04131 0 2.64236 0.579463 1.61091 1.61091C0.579463 2.64236 0 4.04131 0 5.5C0 6.95869 0.579463 8.35764 1.61091 9.38909C2.64236 10.4205 4.04131 11 5.5 11ZM7.92773 4.49023L5.17773 7.24023C4.97578 7.44219 4.64922 7.44219 4.44941 7.24023L3.07441 5.86523C2.87246 5.66328 2.87246 5.33672 3.07441 5.13691C3.27637 4.93711 3.60293 4.93496 3.80273 5.13691L4.8125 6.14668L7.19727 3.75977C7.39922 3.55781 7.72578 3.55781 7.92559 3.75977C8.12539 3.96172 8.12754 4.28828 7.92559 4.48809L7.92773 4.49023Z"
        fill="#038C00"
      />
    </g>
    <defs>
      <clipPath id="clip0_301_1691">
        <rect width="11" height="11" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
